import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../config";

// simple module-level cache so the teaser and the page share one request
let cached = null;
let inflight = null;

export const useLeaderboard = () => {
  const [data, setData] = useState(cached);
  const [loading, setLoading] = useState(!cached);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (cached) return;
    if (!inflight) {
      inflight = axios.get(`${API}/leaderboard`).then((r) => {
        cached = r.data;
        return r.data;
      });
    }
    let mounted = true;
    inflight
      .then((d) => {
        if (mounted) {
          setData(d);
          setLoading(false);
        }
      })
      .catch((e) => {
        inflight = null;
        if (mounted) {
          setError(e);
          setLoading(false);
        }
      });
    return () => {
      mounted = false;
    };
  }, []);

  return { data, loading, error };
};
